export default __webpack_public_path__ + "static/media/notif_medico_guardia.b2c2151a.wav";